import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../services/api';

interface AvailableCarsState {
  isAvailable: boolean | null;
  affectedTrip: any;
  carPlateNumber: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AvailableCarsState = {
  isAvailable: false,
  affectedTrip: null,
  carPlateNumber: '',
  loading: false,
  error: null,
};

export const checkCarAvailability = createAsyncThunk(
  'availableCars/check',
  async ({ tripCode, carTypeId,carId }: { tripCode: string; carTypeId: number,carId: number }, { rejectWithValue }) => {
    try {
      const response: any = await api.checkCarAvailability(tripCode, carTypeId, carId);    
      // Extract data from response - adjust based on your API structure
      const data = response.data || response;   
      const isAvailable = data.isAvailable;
      const affectedTrip = data.affectedTrip;
      const carPlateNumber = data.carPlateNumber;   
         
      return {
        isAvailable,
        affectedTrip,
        carPlateNumber
      };
    } catch (error: any) {
      console.error('Availability Check Error:', error);
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to check availability');
    }
  }
);

const availableCarsSlice = createSlice({
  name: 'availableCars',
  initialState,
  reducers: {
    clearAvailability: (state) => {
      state.isAvailable = false;
      state.affectedTrip = null;
      state.carPlateNumber = '';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkCarAvailability.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isAvailable = null;
      })
      .addCase(checkCarAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.isAvailable = action.payload.isAvailable;
        state.affectedTrip = action.payload.affectedTrip;
        state.carPlateNumber = action.payload.carPlateNumber;
      })
      .addCase(checkCarAvailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || action.error.message || 'Failed to check availability';
        state.isAvailable = null;
      });
  },
});

export const { clearAvailability } = availableCarsSlice.actions;
export default availableCarsSlice.reducer;